/*
  The shared shape of a quiet transcript line, used by the change, stopped and exhausted
  projections and by a slide-version turn.

  These were a bordered box each with a filled accent icon tile, roughly three lines tall,
  and the transcript puts a 28px turn gap between siblings: a run of four events therefore
  filled a screen with four identical panels and the chat read as a records table rather
  than as an assistant accounting for its own work. One 20px line each replaces them, and
  a run of them shares the rail ConversationTranscript draws.

  They live here rather than in one component because a turn and a projection are different
  things (one is a message, one is an event) that have to look the same. Two copies of the
  same class list is how they stop looking the same.
*/
export const activityRow = 'flex min-h-6 items-center gap-2 text-[0.8125rem] leading-5'
// Aligns a second line under the row's text rather than under its icon: 14px glyph plus
// the row's 8px gap.
export const activityDetail = 'pl-5.5 text-xs'
export const activityGlyph = 'shrink-0 [&>svg]:size-3.5'
export const activityAction = 'h-6 shrink-0 gap-1 px-2 text-xs'
export const activityQuiet = 'text-muted-foreground'
export const activityNotable = 'text-warning'
